module.exports = __webpack_public_path__ + "static/media/iconehosptitalisationavecassistance.51af81a6.png";